import { PageContainer } from '../../../shared/PageContainer';
import TextSnippetIcon from '@mui/icons-material/TextSnippet';
import { PageDefaultSegment, useFeedback } from "@sis/react-library";
import { useState } from 'react';
import { FormSamplesOutput } from '../FormSamplesOutput';
import { callMimicApi } from '../../../../utils/commonUtils';
import { FormSamplesValidationForm } from './FormSamplesValidationForm';
import { FormSamplesValidationPageInfo } from './FormSamplesValidationPageInfo';

/////////////////////////////////////////////////////////////////////////////////////////////
// Existing interface (would be defined elsewhere in the project).
/////////////////////////////////////////////////////////////////////////////////////////////
export interface ExampleDto {
    required: string;
    number?: number;
    minLength: string;
    maxLength?: string;
    minValue?: number;
    maxValue?: number;
    minAndMaxValue: number;
    password?: string;
    confirmPassword?: string;
    notEqualCompare1?: string;
    notEqualCompare2?: string;
    email?: string;
    custom?: string;
}

export const FormSamplesValidationPage = () => {

  const [submittedValues, setSubmittedValues] = useState<ExampleDto | undefined>(undefined)
  const [submitting, setSubmitting] = useState(false);
  const { showError } = useFeedback();

  const handleSubmit = async (values: ExampleDto) => {
    setSubmitting(true);
    setSubmittedValues(values);

    try {
      // In the api call, uncomment the exception in there to test errors coming from the api
      await callMimicApi();
    } catch (ex) {
      showError(`An error occured: ${ex}`);
      return false;
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <PageContainer
      heading='Form Samples - Validation'
      icon={<TextSnippetIcon />}
      pageInfo={<FormSamplesValidationPageInfo />}
      wrapRightElementForMobile={false}
    >
      <PageDefaultSegment width={600}>
        <FormSamplesValidationForm
          submitting={submitting}
          onSubmit={handleSubmit}
        />
      </PageDefaultSegment>
      <FormSamplesOutput width={600} submittedValues={submittedValues} />
    </PageContainer>
  )
}
